"use client";

import { Core } from "@faire/slate/foundation/color";
import { PromotionalEventType } from "@faire/web-api--source/indigofair/common/PromotionalEventType";
import { SVGIcon } from "@faire/web/slate/icons/SVGIcon";
import { eventsThemeColors } from "@faire/web/slate/Theme/eventsThemeColors";
import React from "react";

interface IProps extends SVGIcon.IProps {
  /**
   * @default: false -> text color: white
   * When set to true, text color is Event Primary Dark
   * Sun color is always Event Secondary
   */
  lightBackground?: boolean;
  sunColor?: string;
}

export const SummerMarketPrimaryLogo: React.FC<IProps> = ({
  lightBackground,
  sunColor,
  ...rest
}) => {
  const textColor = lightBackground
    ? eventsThemeColors[PromotionalEventType.FAIRE_SUMMER_MARKET_2022]
        .primaryDark
    : Core.text.primaryInverse;
  const iconColor =
    sunColor ??
    eventsThemeColors[PromotionalEventType.FAIRE_SUMMER_MARKET_2022].secondary;
  return (
    <SVGIcon
      width="196"
      height="158"
      viewBox="0 0 196 158"
      fill="none"
      {...rest}
    >
      <path
        d="M3.46784 64.8363H9.37782V44.1681H15.1901V39.8143H9.37782V36.2261C9.37782 34.0732 10.3547 32.5422 12.748 32.5422C13.8225 32.5422 14.7505 32.7335 15.4343 32.9728V28.4755C14.3598 28.1406 13.4806 27.9971 12.0642 27.9971C6.59378 27.9971 3.46784 30.9634 3.46784 36.4653V39.8143H0V44.1681H3.46784V64.8363Z"
        fill={textColor}
      />
      <path
        d="M27.8789 65.3148C31.7863 65.3148 34.0331 63.9273 35.6938 61.7744V64.8363H41.5061V48.4261C41.5061 41.5845 37.0125 39.2881 31.2979 39.2881C25.5833 39.2881 20.8456 41.7281 20.3571 47.5649H26.0717C26.3648 45.0771 27.8789 43.6418 30.956 43.6418C34.4239 43.6418 35.5961 45.3163 35.5961 48.6653V49.9571H32.4213C25.0949 49.9571 19.3314 52.0622 19.3314 57.8991C19.3314 63.114 23.19 65.3148 27.8789 65.3148ZM29.2954 61.1524C26.3648 61.1524 25.1926 59.765 25.1926 57.6599C25.1926 54.5979 28.0743 53.5932 32.5678 53.5932H35.5961V56.081C35.5961 59.2865 32.9097 61.1524 29.2954 61.1524Z"
        fill={textColor}
      />
      <path
        d="M52.8345 35.6998C54.7883 35.6998 56.3512 34.2645 56.3512 32.3986C56.3512 30.4849 54.7883 29.0496 52.8345 29.0496C50.8808 29.0496 49.3179 30.4849 49.3179 32.3986C49.3179 34.2645 50.8808 35.6998 52.8345 35.6998ZM49.9528 64.8363H55.8628V39.8143H49.9528V64.8363Z"
        fill={textColor}
      />
      <path
        d="M64.5927 64.8363H70.5027V51.823C70.5027 46.5124 73.6286 44.8857 78.8059 44.8379V39.4316C74.5078 39.4794 72.1145 41.3453 70.5027 44.503V39.8143H64.5927V64.8363Z"
        fill={textColor}
      />
      <path
        d="M96.2413 65.3148C102.786 65.3148 107.133 62.4442 107.964 57.1814H102.249C101.809 59.6214 99.9533 61.0089 96.3878 61.0089C91.992 61.0089 89.5498 58.3297 89.3544 53.5932H108.061V51.9187C108.061 42.972 102.347 39.2881 95.9971 39.2881C88.7195 39.2881 83.2979 44.4551 83.2979 52.2057V52.5885C83.2979 60.4826 88.7195 65.3148 96.2413 65.3148ZM89.4521 49.7179C90.0382 45.8426 92.4315 43.4983 95.9971 43.4983C99.6603 43.4983 101.907 45.412 102.2 49.7179H89.4521Z"
        fill={textColor}
      />
      <path
        d="M11.185 110.168C17.7299 110.168 21.3931 107.249 21.3931 102.178C21.3931 96.8674 17.8276 95.4321 11.82 94.5231C7.766 93.8532 6.54493 93.1356 6.54493 91.3176C6.54493 89.5474 8.05906 88.3513 10.5989 88.3513C13.3341 88.3513 14.6528 89.4038 15.1413 91.7003H20.6117C19.9767 86.0548 15.8251 84.1411 10.5989 84.1411C5.81229 84.1411 1.0257 86.6289 1.0257 91.6525C1.0257 96.3411 3.51668 98.207 10.257 99.2595C14.0179 99.8815 15.7274 100.647 15.7274 102.704C15.7274 104.809 14.3109 105.91 11.1362 105.91C7.66832 105.91 6.34956 104.427 6.05651 101.891H0.488428C0.732642 107.202 4.59122 110.168 11.185 110.168Z"
        fill={textColor}
      />
      <path
        d="M36.6512 110.168C40.8028 110.168 43.4892 108.206 44.7591 105.766V109.689H50.6691V84.6674H44.7591V99.5466C44.7591 103.518 41.975 105.527 38.8003 105.527C35.3813 105.527 33.7694 103.805 33.7694 100.025V84.6674H27.8595V100.695C27.8595 107.345 31.6204 110.168 36.6512 110.168Z"
        fill={textColor}
      />
      <path
        d="M59.2028 109.689H65.1128V94.7144C65.1128 90.887 67.7991 88.9732 70.7297 88.9732C73.6114 88.9732 75.2721 90.5521 75.2721 94.236V109.689H81.1821V94.7144C81.1821 90.887 83.8684 88.9732 86.799 88.9732C89.7295 88.9732 91.3414 90.5521 91.3414 94.236V109.689H97.2513V93.8532C97.2513 86.9638 93.4416 84.1411 88.7527 84.1411C85.5779 84.1411 82.0612 85.5285 80.1075 88.6383C78.8376 85.5285 76.2001 84.1411 72.8788 84.1411C69.1179 84.1411 66.3338 86.1505 65.1128 88.4948V84.6674H59.2028V109.689Z"
        fill={textColor}
      />
      <path
        d="M105.565 109.689H111.475V94.7144C111.475 90.887 114.162 88.9732 117.092 88.9732C119.974 88.9732 121.635 90.5521 121.635 94.236V109.689H127.545V94.7144C127.545 90.887 130.231 88.9732 133.161 88.9732C136.092 88.9732 137.704 90.5521 137.704 94.236V109.689H143.614V93.8532C143.614 86.9638 139.804 84.1411 135.115 84.1411C131.94 84.1411 128.424 85.5285 126.47 88.6383C125.2 85.5285 122.563 84.1411 119.241 84.1411C115.48 84.1411 112.696 86.1505 111.475 88.4948V84.6674H105.565V109.689Z"
        fill={textColor}
      />
      <path
        d="M163.162 110.168C169.707 110.168 174.054 107.297 174.884 102.034H169.169C168.73 104.474 166.874 105.862 163.308 105.862C158.912 105.862 156.47 103.183 156.275 98.4462H174.982V96.7717C174.982 87.825 169.267 84.1411 162.917 84.1411C155.64 84.1411 150.218 89.3081 150.218 97.0587V97.4415C150.218 105.336 155.64 110.168 163.162 110.168ZM156.372 94.5709C156.959 90.6956 159.352 88.3513 162.917 88.3513C166.581 88.3513 168.827 90.265 169.12 94.5709H156.372Z"
        fill={textColor}
      />
      <path
        d="M181.787 109.689H187.697V96.676C187.697 91.3654 190.823 89.7387 196 89.6909V84.2846C191.702 84.3325 189.309 86.1983 187.697 89.356V84.6674H181.787V109.689Z"
        fill={textColor}
      />
      <path
        d="M2.44214 157.533H8.35212V142.558C8.35212 138.73 11.0385 136.816 13.969 136.816C16.8508 136.816 18.5114 138.395 18.5114 142.079V157.533H24.4214V142.558C24.4214 138.73 27.1077 136.816 30.0383 136.816C32.9689 136.816 34.5807 138.395 34.5807 142.079V157.533H40.4907V141.696C40.4907 134.807 36.6809 131.984 31.992 131.984C28.8172 131.984 25.3006 133.372 23.3469 136.482C22.0769 133.372 19.4394 131.984 16.1181 131.984C12.3572 131.984 9.57319 133.994 8.35212 136.338V132.511H2.44214V157.533Z"
        fill={textColor}
      />
      <path
        d="M55.4961 158.011C59.4035 158.011 61.6503 156.624 63.3109 154.471V157.533H69.1232V141.122C69.1232 134.281 64.6297 131.984 58.9151 131.984C53.2005 131.984 48.4627 134.424 47.9743 140.261H53.6889C53.982 137.773 55.4961 136.338 58.5732 136.338C62.041 136.338 63.2132 138.013 63.2132 141.362V142.653H60.0385C52.7121 142.653 46.9486 144.758 46.9486 150.595C46.9486 155.81 50.8072 158.011 55.4961 158.011ZM56.9125 153.849C53.982 153.849 52.8097 152.461 52.8097 150.356C52.8097 147.294 55.6915 146.289 60.185 146.289H63.2132V148.777C63.2132 151.983 60.5269 153.849 56.9125 153.849Z"
        fill={textColor}
      />
      <path
        d="M77.4234 157.533H83.3334V144.519C83.3334 139.209 86.4594 137.582 91.6367 137.534V132.128C87.3385 132.176 84.9452 134.042 83.3334 137.199V132.511H77.4234V157.533Z"
        fill={textColor}
      />
      <path
        d="M98.3629 157.533H104.273V145.237L113.846 157.533H120.684L109.939 143.993L119.854 132.511H113.406L104.273 143.514V120.932H98.3629V157.533Z"
        fill={textColor}
      />
      <path
        d="M136.355 158.011C142.9 158.011 147.247 155.14 148.078 149.878H142.363C141.923 152.318 140.067 153.705 136.502 153.705C132.106 153.705 129.664 151.026 129.468 146.289H148.175V144.615C148.175 135.668 142.461 131.984 136.111 131.984C128.834 131.984 123.412 137.151 123.412 144.902V145.285C123.412 153.179 128.834 158.011 136.355 158.011ZM129.566 142.414C130.152 138.539 132.546 136.194 136.111 136.194C139.774 136.194 142.021 138.108 142.314 142.414H129.566Z"
        fill={textColor}
      />
      <path
        d="M163.674 157.963C165.482 157.963 166.752 157.676 167.68 157.341V152.748C166.849 153.083 165.97 153.227 164.798 153.227C162.942 153.227 161.867 152.222 161.867 150.021V136.864H167.484V132.511H161.867V127.009H155.957V132.511H152.538V136.864H155.957V150.547C155.957 155.284 158.595 157.963 163.674 157.963Z"
        fill={textColor}
      />
      <path
        d="M188.466 29.5337H165.166L185.35 17.9048L183.047 13.9384L162.863 25.5673L174.513 5.41954L170.525 3.1208L158.89 23.2686V0.0107422H154.284V23.2686L142.634 3.1208L138.645 5.41954L150.295 25.5673L130.126 13.9384L127.823 17.9048L147.992 29.5337H124.708V34.1312H147.992L127.823 45.7601L130.126 49.7416L150.295 38.1127L138.645 58.2454L142.634 60.5442L154.284 40.4114V63.6542H158.89V40.4114L170.525 60.5442L174.513 58.2454L162.863 38.1127L183.047 49.7416L185.35 45.7601L165.166 34.1312H188.466V29.5337Z"
        fill={iconColor}
      />
    </SVGIcon>
  );
};
